if (typeof window !== 'undefined') {
  CanvasRenderingContext2D.prototype.dashedLine = function (x1, y1, x2, y2, dashLen) {
    this.beginPath();
    dashLen = dashLen || 1;

    this.moveTo(x1, y1);

    const dX = x2 - x1;
    const dY = y2 - y1;
    const dashes = Math.floor(Math.sqrt(dX * dX + dY * dY) / dashLen);
    const dashX = dX / dashes;
    const dashY = dY / dashes;

    let q = 0;
    while (q++ < dashes) {
      x1 += dashX;
      y1 += dashY;
      this[q % 2 == 0 ? 'moveTo' : 'lineTo'](x1, y1);
    }
    this[q % 2 == 0 ? 'moveTo' : 'lineTo'](x2, y2);
    this.stroke();
  };
}



// WEBPACK FOOTER //
// ./src/modules/canvasUtils.js